<template>
  <div class="stat-card" :class="{ 'stat-card--clickable': clickable }" @click="$emit('click')">
    <div class="stat-card-icon" :style="{ background: iconBg, color: iconColor }">
      <v-icon :color="iconColor" size="22">{{ icon }}</v-icon>
    </div>
    <div class="stat-card-body">
      <div class="stat-card-value">{{ value }}</div>
      <div class="stat-card-label">{{ label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatCard",
  props: {
    icon: { type: String, default: "mdi-chart-box" },
    value: { type: [String, Number], default: "0" },
    label: { type: String, default: "" },
    iconColor: { type: String, default: "#1565C0" },
    iconBg: { type: String, default: "rgba(21,101,192,0.1)" },
    clickable: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.stat-card {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff;
  border: 1px solid #ECEFF1;
  border-radius: 12px;
  padding: 16px;
  transition: transform 0.2s, box-shadow 0.2s;
}

.stat-card--clickable {
  cursor: pointer;
}

.stat-card--clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.stat-card-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-card-body {
  min-width: 0;
}

.stat-card-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #263238;
  line-height: 1.1;
}

.stat-card-label {
  font-size: 0.8rem;
  color: #78909C;
  margin-top: 2px;
}
</style>
